import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { useLinkProvider, useBaseurl, withBaseurl } from '@myst-theme/providers';
import { MyST } from './MyST.js';
export const Header = ({ node }) => {
    return (_jsx("header", { className: "py-1 pl-3 m-0 border-b border-gray-100 bg-gray-50 dark:bg-slate-900 dark:border-gray-800", children: _jsx(MyST, { ast: node.children }) }));
};
export const Footer = ({ node }) => {
    return (_jsx("footer", { className: "py-1 pl-3 m-0 border-t border-gray-100 bg-gray-50 dark:bg-slate-900 dark:border-gray-800", children: _jsx(MyST, { ast: node.children }) }));
};
export const CardTitle = ({ node }) => {
    return (_jsx("div", { className: "pt-3 font-bold group-hover:underline", children: _jsx(MyST, { ast: node.children }) }));
};
function getParts(children) {
    var _a, _b;
    const parts = {};
    if (!Array.isArray(children))
        return parts;
    const next = [...children];
    if (((_a = next[0]) === null || _a === void 0 ? void 0 : _a.type) === 'header') {
        parts.header = next.splice(0, 1);
    }
    if (((_b = next[next.length - 1]) === null || _b === void 0 ? void 0 : _b.type) === 'footer') {
        parts.footer = next.splice(-1, 1);
    }
    parts.body = next;
    return parts;
}
function ExternalOrInternalLink({ to, className, isStatic, prefetch = 'intent', children, }) {
    const Link = useLinkProvider();
    const baseurl = useBaseurl();
    if (to.startsWith('http') || isStatic) {
        return (_jsx("a", { href: to, className: className, target: "_blank", rel: "noopener noreferrer", children: children }));
    }
    return (_jsx(Link, { to: withBaseurl(to, baseurl), className: className, prefetch: prefetch, children: children }));
}
export const CardRenderer = ({ node }) => {
    const parts = getParts(node.children);
    const url = node.url;
    const isStatic = node.static || false;
    const link = !!url;
    const sharedStyle = 'my-5 rounded shadow dark:shadow-neutral-800 overflow-hidden border border-gray-100 dark:border-gray-800 flex flex-col';
    if (link) {
        return (_jsxs(ExternalOrInternalLink, { to: url, isStatic: isStatic, className: classNames(sharedStyle, 'text-inherit hover:text-inherit', 'block font-normal no-underline hover:no-underline cursor-pointer group', 'hover:border-blue-500 dark:hover:border-blue-400'), children: [_jsx(MyST, { ast: parts.header }), _jsx("div", { className: "flex-grow px-4 py-2", children: _jsx(MyST, { ast: parts.body }) }), _jsx(MyST, { ast: parts.footer })] }));
    }
    return (_jsxs("div", { className: sharedStyle, children: [_jsx(MyST, { ast: parts.header }), _jsx("div", { className: "flex-grow px-4 py-2", children: _jsx(MyST, { ast: parts.body }) }), _jsx(MyST, { ast: parts.footer })] }));
};
const CARD_RENDERERS = {
    card: CardRenderer,
    cardTitle: CardTitle,
    header: Header,
    footer: Footer,
};
export default CARD_RENDERERS;
